import { Pipe, PipeTransform } from '@angular/core';
import {JOB_TYPE, JobTypesFriendlyNamesMap} from '@app/core/model/job.model';

@Pipe({
    name: 'ngcJobTypeFriendlyName'
})
export class JobTypeFriendlyNamePipe implements PipeTransform {

    transform(value: JOB_TYPE): any {
        if (JobTypesFriendlyNamesMap.has(value)) {
            return JobTypesFriendlyNamesMap.get(value);
        } else {
            return value ? value.replace(/[_-]/g, ' ') : '';
        }
    }

}
